/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmoreprivate2Inputs */

const zh_share_learnmoreprivate2 = /** @type {(inputs: Share_Learnmoreprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私密：仅创建者可以访问此内容。`)
};

const en_share_learnmoreprivate2 = /** @type {(inputs: Share_Learnmoreprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private: Only you can access this content.`)
};

const es_share_learnmoreprivate2 = /** @type {(inputs: Share_Learnmoreprivate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privado: Solo tú puedes acceder a este contenido.`)
};

/**
* | output |
* | --- |
* | "Private: Only you can access this content." |
*
* @param {Share_Learnmoreprivate2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmoreprivate2 = /** @type {((inputs?: Share_Learnmoreprivate2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmoreprivate2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmoreprivate2(inputs)
	if (locale === "en") return en_share_learnmoreprivate2(inputs)
	return es_share_learnmoreprivate2(inputs)
});
export { share_learnmoreprivate2 as "share_learnMorePrivate" }